export default __webpack_public_path__ + "static/media/unassignedActive.7874770a.svg";